import { EmanetXHata } from '@emanetx/sdk';

interface SilmeAyrintilar {
  sebep?: string;
  mesaj?: string;
  sayilar?: Record<string, number>;
}

/**
 * Silme hatasini kullanici dostu Turkce metne donustur.
 * 409 + kod=silinemez ise ayrintili sayilar gosterilir.
 * Diger hatalar generic mesaj.
 */
export function silmeHatasiniFormatla(err: unknown): string {
  if (err instanceof EmanetXHata && err.durum === 409 && err.kod === 'silinemez') {
    const a = (err.ayrintilar ?? {}) as SilmeAyrintilar;
    const parcalar: string[] = [];
    if (a.sayilar?.aktifKiralama) parcalar.push(`${a.sayilar.aktifKiralama} aktif kiralama`);
    if (a.sayilar?.aktifRezervasyon)
      parcalar.push(`${a.sayilar.aktifRezervasyon} aktif rezervasyon`);
    if (a.sayilar?.toplamKiralama && parcalar.length === 0) {
      parcalar.push(`${a.sayilar.toplamKiralama} geçmiş kiralama kaydı`);
    }
    const baslik = a.mesaj ?? 'Silinemez.';
    return parcalar.length > 0 ? `${baslik} (${parcalar.join(', ')})` : baslik;
  }
  return (err as Error).message ?? 'Silme başarısız.';
}
